import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  IconButton,
  MenuItem,
  Snackbar,
  Autocomplete,
} from "@mui/material";
import {
  ActionMsg,
  Breadcrumb,
  Cancel,
  CTSinput,
  CTSinputNo,
  HandleCloseSnackbar,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import styles from "../../../styles.module.css";
import { Balance } from "@mui/icons-material";
import {
  addBom,
  editDeleteBom,
  getProductList,
  getRMList,
} from "../../../actions/actions";
import bomService from "../../../services/utility/bom.Service"
import rmMasterService from "../../../services/masters/rmMaster.Service"
import productMasterService from "../../../services/masters/productMaster.Service"
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const BomAdd = () => {
  // const classes = useStyles();
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const editid = editData ? editData.bom_id : null;
  console.log("edit:", editData);
  let navigate = useNavigate();
  const [isSet, setIsSet] = useState(false);
  // const [schedule_date, setSchedule_date] = useState(new Date());
  const [data, setData] = useState({
    prod_id: editData ? editData.prod_id : "",
    prod_code: editData ? editData.prod_code : "",
    qty: editData ? editData.qty : "",
    prod_description: editData ? editData.prod_description : "",
    // schedule_date: editData ? editData.schedule_date : new Date(),
  });

  const [prod, setProd] = useState([]);

  /////////////////////

  // const { rm } = useSelector((state) => state.rm);
  // const { product } = useSelector((state) => state.product);

  // useEffect(() => {
  //   dispatch(getRMList({ page: 0, size: 999, searchKey: "" }));
  //   dispatch(getProductList({ page: 0, size: 999, searchKey: "" }));
  // }, [dispatch]);
  const [rm, setRm] = useState([]);
  const [product, setProduct] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const [rmData, productData] = await Promise.all([
          rmMasterService.getRMList({ page: 0, size: 999, searchKey: "" }),
          productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
        ]);

        setRm(rmData);
        setProduct(productData);
      } catch (error) {
        console.error("Data fetching failed", error);
      }
    }

    fetchData();
  }, []);

  ///////////////////////////

  const handleChangeRMName = (e, index) => {
    const value = e.target.value;
    const array = [...bom_details];
    array[index].rm_name = value; // Update only the current row's RM name
    setBomDetails(array);
  };

  const handleChange = ({ target }) => {
    const value = target.value;
    if (target.name === "prod_code") {
      const selectedProduct = product.find((p) => p.prod_code === value);
      setData({
        [target.name]: value,
        prod_id: selectedProduct?.prod_id || "",
        prod_description: selectedProduct
          ? selectedProduct.prod_description
          : "",
      });
    } else {
      setData({
        ...data,
        [target.name]: value,
      });
    }
    data[target.name] = target.value;
  };
  // const handleChangeInput = (e, i) => {
  //   const array = bom_details;
  //   let result = array[i];
  //   result[e.target.name] = e.target.value; // Update the specific field for the row
  //   array[i] = result;
  //   setBomDetails(array);
  //   setIsUpdateArray(isUpdateArray ? false : true);
  // };

  const [successMessage, setSuccessMessage] = useState(null);
  // const respMsgState = useSelector((state) => state.bom.message);
  // const { shouldShowMsg, responseMessage } = useMessageHandler(
  //   null,
  //   navigate,
  //   setSuccessMessage,
  //   respMsgState
  // );

  // useEffect(() => { }, [shouldShowMsg, responseMessage]);

  const onSubmit = async (event) => {
    const bom_Data = {
      ...data,
      bom_id: editid,
      bom_details: JSON.stringify(bom_details),
      changedUpdatedValue: "edit",
    };
    try {
      if (editData) {
        await bomService.editDeleteBom(bom_Data);
      } else {
        await bomService.addBom(bom_Data);
      }
      setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
      setTimeout(() => navigate(-1), 1000);
      //  setTimeout(()=>navigate(-1),1000);
    } catch (error) {
      setSuccessMessage("Error occurred");
    }
  };

  const [isUpdateArray, setIsUpdateArray] = useState(false);

  const [bom_details, setBomDetails] = useState(
    editData
      ? JSON.parse(editData.bom_details)
      : [
        {
          sr_no: '',
          rm_name: "",
          rm_qty: "",
        },
      ]
  );

  console.log("SD", bom_details);
  const handleChangeInput = (e, i) => {
    const array = [...bom_details];
    let result = array[i];
    result[e.target.name] = e.target.value;
    result.srno = i + 1;
    array[i] = result;
    setBomDetails(array);
    setIsUpdateArray(!isUpdateArray);

    array[i] = result;

    setIsSet(isSet ? false : true);
  };

  const handleRemoveScheduledetails = (index) => {
    const values = [...bom_details];
    values.splice(index, 1);
    setBomDetails(values);
    setIsUpdateArray(isUpdateArray ? false : true);
  };

  const handleAddScheduleFields = () => {
    setBomDetails([
      ...bom_details,
      {
        sr_no: bom_details.length + 1,
        rm_name: "",
        rm_qty: "",
      },
    ]);
  };

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Bom" }]} />


        <Box>

          <Box sx={{ display: "flex" }}>
            <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
              <Grid item md={7} sm={6} xs={12}>
                <Box sx={{ display: "flex" }}>
                  <Typography className={`${styles.header_txt}`}>
                    Add Bom
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={1}>

              <Grid item xs={12} sm={6} >
                <Grid container spacing={0.6}>

                  <Grid item xs={10} sm={10}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                        // gap: { xs: 1, sm: 2 },
                      }}
                    >
                      <Typography className={`${styles.label_Txt}`}>
                        Quantity
                      </Typography>

                      <CTSinput
                        size="small"
                        fullWidth
                        type="text"
                        onChange={handleChange}
                        name="qty"
                        value={data.qty}
                        InputProps={{
                          className: styles.CTSinput_Box,
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6} >
                <Grid container spacing={0.6}>
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                        // gap: { xs: 1, sm: 2 },
                      }}
                    >
                      <Typography className={`${styles.label_Txt}`}>
                        Product Code
                      </Typography>

                      <Autocomplete
                        disablePortal
                        options={product || []}
                        // clearIcon={false}
                        getOptionLabel={(option) =>
                          typeof option === 'string' ? option : option.prod_code || ''
                        }
                        value={
                          product.find((p) => p.prod_code === data.prod_code) ||
                          (data.prod_code ? { prod_code: data.prod_code } : null)
                        }
                        onChange={(event, newValue) => {
                          handleChange({
                            target: {
                              name: 'prod_code',
                              value: newValue ? newValue.prod_code : '',
                            },
                          });
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.prod_code === value.prod_code
                        }
                        renderOption={(props, option) => (
                          <MenuItem {...props} className={styles.cts_lable}>
                            {option.prod_code}
                          </MenuItem>
                        )}
                        renderInput={(params) => (
                          <CTSinput
                            {...params}
                            // label="Product Code"
                            // placeholder="Select or type product code"
                            variant="outlined"
                            size="small"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              ...params.InputProps,
                              className: styles.CTSinput_Box,
                            }}
                          />
                        )}
                        sx={{ width: '100%' }}
                      />

                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                        // gap: { xs: 1, sm: 2 },
                      }}
                    >
                      <Typography className={`${styles.label_Txt}`}>
                        Product Description
                      </Typography>
                      <CTSinput
                        size="small"
                        fullWidth
                        value={data.prod_description}
                        variant="outlined"
                        InputProps={{
                          readOnly: true,
                          className: styles.CTSinput_Box,
                          style: {
                            backgroundColor: "#f0f0f0",
                          },
                        }}
                      />

                    </Box>
                  </Grid>
                </Grid>
              </Grid>


              <Grid item xs={12}>
                <TableContainer className={`${styles.list_tbl_container}`}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell
                          align="left" sx={{ width: '10%' }} className={`${styles.table_head}`}>
                          Sr No
                        </StyledTableCell>
                        <StyledTableCell align="left" className={`${styles.table_head}`} width="18%">
                          RM Name
                        </StyledTableCell>
                        <StyledTableCell sx={{ width: '20%' }}
                          className={`${styles.table_head}`} align="left">
                          RM Quantity
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`} >
                          Action
                        </StyledTableCell>

                      </StyledTableRow>
                    </TableHead>
                    <TableBody sx={{ backgroundColor: '#fff' }}>
                      {bom_details &&
                        bom_details.map((row, index) => (
                          <StyledTableRow key={index}>
                            <StyledTableCell align="left">
                              {index + 1}
                            </StyledTableCell>
                            <StyledTableCell align="left">

                              <CTSinput
                                select
                                size="small"
                                fullWidth
                                onChange={(e) => handleChangeRMName(e, index)}
                                name="rm_name"
                                value={row.rm_name}
                                variant="standard"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                  disableUnderline: true,
                                }}>
                                {rm &&
                                  rm.map((rm) => (
                                    <MenuItem key={rm.rm_id} value={rm.rm_name} className={`${styles.cts_lable}`}>
                                      {rm.rm_name}
                                    </MenuItem>
                                  ))}
                              </CTSinput>
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <CTSinput
                                fullWidth
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                size="small"
                                type="text"
                                name="rm_qty"
                                value={row.rm_qty}
                                onChange={(e) => handleChangeInput(e, index)}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center" >
                              <Box>
                                <IconButton
                                  size="small"
                                  onClick={handleAddScheduleFields}
                                >
                                  <AddIcon
                                    sx={{
                                      fontSize: "16px",
                                      color: "#1b52d1",
                                      border: "1px solid #1b52d1",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </IconButton>
                                {index === 0 ? (
                                  <IconButton
                                    disabled
                                    size="small"
                                    style={{ fontSize: "12px", color: "red" }}
                                  >
                                    <DeleteForeverIcon
                                      sx={{
                                        color: "#c0c0c0",
                                        fontSize: "18px",
                                      }}
                                    />
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleRemoveScheduledetails(index)
                                    }
                                    style={{ fontSize: "12px", color: "red" }}
                                  >
                                    <DeleteForeverIcon
                                      sx={{ fontSize: "18px" }}
                                    />
                                  </IconButton>
                                )}
                              </Box>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>



              <Grid item xs={12} className={`${styles.grid_input}`}>
                <Box className={`${styles.btn_container}`}>
                  <Box>
                    <Button
                      id={`${styles.btn_save}`}
                      type="submit">
                      <SaveIcon className={`${styles.btn_cancel_txt}`} />{" "}
                      <Typography className={`${styles.btn_cancel_txt}`}> {editData ? "Update" : "Save"}</Typography>
                    </Button>
                  </Box>
                  <Box>
                    <Cancel />
                  </Box>
                </Box>
              </Grid>


            </Grid>
          </form>
        </Box>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};
export default BomAdd;
